import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import VuiBox from "components/VuiBox";
import { useApi } from "hooks/useAPI";
import { QuickBooksService, QuickBooksAccountSummary } from "services/QuickBooksService";
import { getLocalTime } from "utils/getLocalTime";
import { type Merchant } from "types/merchant";
import { QuickBooksAccountCard } from "./QuickBooksAccountCard";

export const QuickBooksAccountCards = () => {
  const { get } = useApi();
  const [loading, setLoading] = useState<boolean>(false);
  const [accounts, setAccounts] = useState<QuickBooksAccountSummary[]>([]);

  const selectedMerchant: Merchant = useSelector(
    (state: any) => state.merchants.selectedMerchant
  );
  const { startDate, endDate } = useSelector((state: any) => state.common);

  useEffect(() => {
    const fetchAccountsSummary = async () => {
      const quickBooksService = new QuickBooksService(get);
      const { startDateString, endDateString } = getLocalTime(
        startDate,
        endDate
      );

      setLoading(true);
      try {
        const result = await quickBooksService.getAccountBalancesSummary({
          merchantId: selectedMerchant.id,
          start: startDateString,
          end: endDateString,
        });
        setAccounts(result.data || []);
      } catch (error) {
        console.error("Error fetching QuickBooks accounts summary:", error);
        setAccounts([]);
      }
      setLoading(false);
    };

    if (selectedMerchant?.quickbooksConnected && startDate && endDate) {
      fetchAccountsSummary();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMerchant, startDate, endDate]);

  if (!selectedMerchant?.quickbooksConnected || accounts.length === 0) {
    return null;
  }

  return (
    <VuiBox mb={3}>
      <Grid container spacing={3}>
        {accounts.map((account) => (
          <Grid item xs={12} sm={6} lg={3} key={account.qbAccountId}>
            <VuiBox mb={3}>
              <QuickBooksAccountCard
                account={account}
                loading={loading}
                currency={selectedMerchant.currency || "USD"}
              />
            </VuiBox>
          </Grid>
        ))}
      </Grid>
    </VuiBox>
  );
}; 